import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface HomeState {
  // Add home-specific state here
  isLoading: boolean;
}

const initialState: HomeState = {
  isLoading: false,
};

export const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
});

export const { setLoading } = homeSlice.actions;
export const homeReducer = homeSlice.reducer;
export default homeSlice.reducer;

